module.exports = __webpack_public_path__ + "media/src/assets/Images/SizePNG-44a9a326a63521ffe657d35610b2b76b.png";